import { isUserSuperAdmin } from "helpers/user";

const isSuperAdmin = isUserSuperAdmin();

const navigation = [
  {
    id: "agents",
    title: "Agents",
    icon: <i className="ph-fill ph-users-three" />,
    navLink: "/agents",
  },
  {
    id: "customers",
    title: "Customers",
    icon: <i className="ph-fill ph-user-list" />,
    navLink: "/customers",
  },
  {
    id: "admins",
    title: "Admins",
    icon: <i className="ph-fill ph-user" />,
    navLink: "/admins",
    hide: !isSuperAdmin,
  },
  {
    id: "call-logs",
    title: "Call Logs",
    icon: <i className="ph-fill ph-phone-call" />,
    navLink: "/call-logs",
    hide: !isSuperAdmin,
  },
  {
    id: "sms-logs",
    title: "SMS Logs",
    icon: <i className="ph-fill ph-equals" />,
    navLink: "/sms-logs",
    hide: !isSuperAdmin,
  },
  {
    id: "tools",
    title: "Tools",
    icon: <i className="ph-fill ph-wrench" />,
    navLink: "/tools",
  },
  {
    id: "integrations",
    title: "Integrations",
    icon: <i className="ph-fill ph-line-segments" />,
    navLink: "/integrations",
  },
  {
    id: "services",
    title: "Services",
    icon: <i className="ph-fill ph-gear" />,
    navLink: "/services",
  },
  {
    id: "routes",
    title: "Routes",
    icon: <i className="ph-fill ph-path" />,
    navLink: "/route-sets/1",
  },
  {
    id: "agents-statistics",
    title: "Agents Statistics",
    icon: <i className="ph-fill ph-wave-sine" />,
    navLink: "/agents-statistics",
  },
  {
    id: "subscription-plans",
    title: "Subscription Plans",
    icon: <i className="ph-fill ph-cards" />,
    navLink: "/subscription-plans",
  },
  {
    id: "system-logs",
    title: "System Logs",
    icon: <i className="ph-fill ph-file-x" />,
    navLink: "/system-logs",
  },
];

export default navigation;
